import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Actualites from "./pages/News";
import LeClub from "./pages/Club";
import Contact from "./pages/Contact";
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Equipes from "./pages/Equipes";
import SectionJeune from "./pages/SectionJeune";
function App() {
  return (
      <Router>
          <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
              <Header />
              <Box component="main" sx={{ flexGrow: 1 }}>
                  <Container maxWidth="xl">
                      <Routes>
                          <Route path="/actualites" element={<Actualites />} />
                          <Route path="/le-club/about-us" element={<LeClub />} />
                          <Route path="/le-club/equipes" element={<Equipes />} />
                          <Route path="/le-club/section-jeune" element={<SectionJeune />} />
                          <Route path="/nous-contacter" element={<Contact />} />
                          <Route path="/" element={<Actualites />} />
                      </Routes>
                  </Container>
              </Box>
              <Footer />
          </Box>
      </Router>
  );
}

export default App;
